// Bileli · modules/media/engine — a tiny event bus for "media settled" moments. why: the fork has no
// query cache to invalidate; viewmodels subscribe and bump their reloadKey when an asset they care about
// finalizes (the signed URL only appears on refetch).

export interface MediaSettledEvent {
  assetId: string;
  courseId?: string;
  lessonId?: string;
  ok: boolean; // false = terminal failure
}

type Listener = (e: MediaSettledEvent) => void;
const listeners = new Set<Listener>();

export function onMediaSettled(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitMediaSettled(e: MediaSettledEvent): void {
  listeners.forEach((cb) => cb(e));
}
